// extracted by mini-css-extract-plugin
module.exports = {"container":"__9wmxTsMk","title":"H1DyaIs_","wordsList":"GDH8edsz","wordItem":"wBOfAhZZ"};